import gql from "graphql-tag";

export const CONTRACTS_ADD_TO_ACCOUNT = gql`
  mutation associateContract($contracts: AssociateContractReq!) {
    associateContract(req: $contracts) {
      outcome
    }
  }
`;

export const IMPERSONATE = gql`
  mutation impersonate($impersonateReq: ImpersonateReq!) {
    impersonate(req: $impersonateReq) {
      token
    }
  }
`;

export const UPDATE_PROFILE_IMAGE = gql`
  mutation updateProfilePicture($fileName: UpdateProfilePictureReq!) {
    updateProfilePicture(req: $fileName) {
      outcome
    }
  }
`;

export const CREATE_BACKOFFICE_OPERATOR = gql`
  mutation backOfficeSignUp($data: BackOfficeSignUpReq!) {
    backOfficeSignUp(req: $data) {
      outcome
    }
  }
`;

export const DISSOCIATE_CONTRACT = gql`
  mutation dissociateContract($contractsId: DissociateContractReq!) {
    dissociateContract(req: $contractsId) {
      outcome
    }
  }
`;

export const VERIFY_UPDATED_EMAIL = gql`
  mutation verifyUpdatedEmail($token: String!) {
    verifyUpdatedEmail(req: { token: $token }) {
      outcome
    }
  }
`;

export const PAY_BILLS = gql`
  mutation payInvoice($req: PayInvoiceReq!) {
    payInvoice(req: $req) {
      path
    }
  }
`;

export const SEND_RICHIESTA_SPURGHO = gql`
  mutation simpleCase($req: SimpleCaseReq) {
    simpleCase(req: $req) {
      outcome
      details {
        caseNumber
      }
    }
  }
`;
export const SEND_SIMPLE_CASE = gql`
  mutation sendSimpleCase($req: SimpleCaseReq) {
    simpleCase(req: $req) {
      outcome
      details {
        caseNumber
        paymentUrl
      }
    }
  }
`;
export const ENABLE_BILL = gql`
  mutation createCase($req: EnableDigitalBillReq!) {
    enableDigitalBill(req: $req) {
      outcome
    }
  }
`;

export const NOTIFY_UPDATE_PASSWORD = gql`
  mutation notifyUpdatePassword {
    notifyUpdatePassword {
      outcome
    }
  }
`;

export const CONSUMPTION_READING = gql`
  mutation consumptionReading($req: ConsumptionReadingReq!) {
    consumptionReading(req: $req) {
      outcome
    }
  }
`;

export const SEND_COMPLEX_CASE = gql`
  mutation complexCase($req: ComplexCaseReq!) {
    complexCase(req: $req) {
      outcome
      details {
        path
        caseNumber
      }
    }
  }
`;

// Todo: Fake - to be changed
export const SEND_CUSTOM_CASE = gql`
  mutation sendCustomCase($req: CustomCase!) {
    sendCase(req: $req) {
      path
    }
  }
`;
export const DISABLE_BILL = gql`
  mutation disableDigitalBill($req: DisableDigitalBillReq!) {
    disableDigitalBill(req: $req) {
      outcome
    }
  }
`;

export const CHANGE_BILL_EMAIL = gql`
  mutation changeDigitalBillEmail($req: ChangeDigitalBillEmailReq!) {
    changeDigitalBillEmail(req: $req) {
      outcome
    }
  }
`;

export const READING_ACTIVATION = gql`
  mutation safeReadingActivation($req: SafeReadingActivationReq!) {
    safeReadingActivation(req: $req) {
      outcome
      details {
        caseId
      }
    }
  }
`;

export const READING_DEACTIVATION = gql`
  mutation safeReadingDeactivation($req: SafeReadingDeactivationReq!) {
    safeReadingDeactivation(req: $req) {
      outcome
      details {
        caseId
      }
    }
  }
`;

export const OPERATOR_UPDATE_EMAIL = gql`
  mutation adminUpdateEmail($req: AdminUpdateEmailReq!) {
    adminUpdateEmail(req: $req) {
      outcome
    }
  }
`;

export const OPERATOR_RESEND_CONFIRMATION_EMAIL = gql`
  mutation adminResendConfirmationEmail($req: AdminResendConfirmationReq!) {
    adminResendConfirmationEmail(req: $req) {
      outcome
    }
  }
`;
export const OPERATOR_TRIGGER_RESET_PASSWORD = gql`
  mutation adminTriggerResetPassword($req: AdminTriggerResetPasswordReq!) {
    adminTriggerResetPassword(req: $req) {
      outcome
    }
  }
`;
export const OPERATOR_RESET_PASSWORD = gql`
  mutation adminResetPassword($req: AdminResetPasswordReq!) {
    adminResetPassword(req: $req) {
      outcome
    }
  }
`;
export const DELETE_PRACTICE = gql`
  mutation deleteCase($req: DeleteCaseReq!) {
    deleteCase(req: $req) {
      outcome
    }
  }
`;
export const SHIPMENT_FREE_CASE = gql`
  mutation shipmentFreeCase($req: ShipmentFreeReq!) {
    shipmentFreeCase(req: $req) {
      outcome
    }
  }
`;

export const SPID_REGISTRATION = gql`
  mutation SPID($req: OnBoardingReq!) {
    onBoarding(req: $req) {
      outcome
    }
  }
`;
export const DELETE_USER = gql`
  mutation DeleteUser {
    deleteUser {
      __typename
      outcome
    }
  }
`;
export const AGIORNA_DATI = gql`
  mutation createCondominiumRegistry($req: CreateCondominiumRegistryReq!) {
    createCondominiumRegistry(req: $req) {
      outcome
      details {
        caseNumber
        caseId
      }
    }
  }
`;
export const CONTRACTS_ADD_TO_ACCOUNT_ADMIN = gql`
  mutation associateCondominiumContract($req: AssociateContractReq!) {
    associateCondominiumContract(req: $req) {
      outcome
      __typename
    }
  }
`;

export const getEvictionForMutation = (mutationName: string) => {
  switch (mutationName) {
    case "associateContract":
    case "dissociateContract":
    case "associateCondominiumContract":
      return [
        "listContracts",
        "searchContract",
        "searchContractList",
        "checkContract",
      ];

    case "payInvoice":
    case "enableDigitalBill":
    case "disableDigitalBill":
    case "changeDigitalBillEmail":
      return [
        "contractDetail",
        "condominiumAdminInvoicesList",
        "municipalInvoicesList",
        "searchContract",
        "listContracts",
        "getPaymentDetail",
      ];

    case "consumptionReading":
    case "safeReadingActivation":
    case "safeReadingDeactivation":
      return ["contractDetail", "getDashboardConsumptions", "listReading"];
    case "simpleCase":
    case "complexCase":
    case "deleteCase":
    case "createCondominiumRegistry":
      return [
        "getCustomer",
        "getOperator",
        "listContracts",
        "searchContract",
        "contractDetail",
        "condominiumAdminInvoicesList",
        "municipalInvoicesList",
        "listReading",
      ];

    case "updateCustomer":
    case "updateProfilePicture":
    case "verifyUpdatedEmail":
    case "signUp":
      return ["getCustomer", "getOperator", "searchUser"];
    
    case "deleteUser":
    case "adminUpdateEmail":
    case "backOfficeSignUp":
    case "adminSignUp":
      return [
        "getCustomer",
        "getOperator",
        "listContracts",
        "searchContract",
        "searchContractList",
        "checkContract",
        "contractDetail",
        "condominiumAdminInvoicesList",
        "municipalInvoicesList",
        "getPaymentDetail",
        "getDashboardConsumptions",
        "listReading",
        "searchUser",
      ];

    case "notifyUpdatePassword":
      return [
        "passwordExpirationCheck"
      ];

    case "adminResendConfirmationEmail":
    case "adminTriggerResetPassword":
    case "adminResetPassword":
    case "SPID":
    case "onBoarding":
    default:
      return [];
  }
};
